package com.essntl.features.message.ui.chat

import com.essntl.features.message.domain.model.WhapiMessageModel

sealed interface ChatEvent {
    data class GetAllWhapiMessagesByChatId(val chatId: String) : ChatEvent
    data class SendWhatsAppMessage(
        val chatId: String,
        val text: String,
        val phoneNumber: String,
        val onSuccess: (message: WhapiMessageModel) -> Unit = {},
    ) : ChatEvent

    data class GetWhapiChatById(val conversationId: String) : ChatEvent
    data class GetWhapiGroupById(val conversationId: String) : ChatEvent

    data class ReactToMessage(
        val whapiMessageId: String,
        val emoji: String?,
        val onSuccess: (message: WhapiMessageModel) -> Unit = {},
    ) : ChatEvent

    data class RemoveParticipantFromGroup(
        val groupId: String,
        val participants: String,
    ) : ChatEvent
}